import CustomSharedLink from '@perpay-web/components/base/CustomSharedLink/CustomSharedLink';
import { getClassName } from '@perpay-web/utils/domUtils';

import styles from './BackButton.scss';

const BackButton = ({ noLink = false, className = '', href = '#', ...rest }) =>
    noLink ? (
        <div className={getClassName(styles['link-back'], className)} {...rest}>
            <div className={styles['arrow-back']} />
        </div>
    ) : (
        <CustomSharedLink
            action='link'
            className={getClassName(styles['link-back'], className)}
            href={href}
            {...rest}
        >
            <div className={styles['arrow-back']} />
        </CustomSharedLink>
    );

export default BackButton;
